<template>
  <BaseNode
    :node="node"
    :editor-errors="editorErrors"
    class="TimerNode"
    color="#896af7"
    icon="far fa-stopwatch"
  >
    {{text}}
    <div
      v-if="doc.isCancelableFlow && node.preventFlowCancel"
      class="TimerNode_preventFlowCancel"
    >+ {{$t('common.Prevent flow cancellation')}}</div>
  </BaseNode>
</template>

<script>
import UI from 'fanplayr-ui'
import nodeMixin from './nodeMixin'

export default {
  mixins: [nodeMixin],
  computed: {
    text() {
      const secs = this.node.waitForSeconds
      const time = UI.format(secs * 1000, 'durationMs')
      const customDataId = this.node.waitUntilAttribute
      if (customDataId) {
        const prop = this.account.customData.find(d => d.id === customDataId)
        const label = prop ? prop.label || prop.id : customDataId
        if (secs) {
          const suffix = secs < 0 ? this.$t('common.before') : this.$t('common.after')
          return this.$t('common.waitUntilTimeSuffixLabel', { time, suffix, label: `"${label}"` })
        }
        return this.$t('common.waitUntilLabel', { label: `"${label}"` })
      }
      return this.$t('common.waitForTime', { time })
    }
  }
}
</script>

<style lang="scss">
.TimerNode {
  .BaseNode_content {
    text-align: center;
  }
}

.TimerNode_preventFlowCancel {
  margin-top: 5px;
  color: #800080;
  font-size: 12px;
}
</style>
